/**
 * Sanitizes a product name by replacing HTML entities for basic symbols,
 * mathematical symbols, non-breaking spaces, and ampersands with their standard equivalents.
 *
 * @function sanitizeProductName
 *
 * @param {string} productName - The product name string to sanitize.
 *   Example: "Premium&nbsp;Mattress &amp; Bed &lt; Deluxe &gt; for 10 &plus; nights"
 *
 * @returns {string} - The sanitized product name with all specified HTML entities
 *   replaced by their standard characters.
 *   Example: "Premium Mattress & Bed < Deluxe > for 10 + nights"
 *
 * @usage
 *   const rawName = "Premium&nbsp;Mattress &amp; Bed &lt; Deluxe &gt; for 10 &plus; nights";
 *   const cleanName = sanitizeProductName(rawName);
 *   console.log(cleanName); // Outputs: "Premium Mattress & Bed < Deluxe > for 10 + nights"
 */

const sanitizeProductName = (productName = ''): string =>
  productName
    .replace(/\u00A0|&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'");

export default sanitizeProductName;
